const CANCEL_TOKEN = 'cancel';

let gallerySessionId = 0;
let sessionCancelled = false;

export const getGallerySessionId = (): number => gallerySessionId;

export const beginGallerySession = (): number => {
	gallerySessionId += 1;
	sessionCancelled = false;
	return gallerySessionId;
};

export const invalidateGallerySession = (): number => {
	sessionCancelled = true;
	gallerySessionId += 1;
	return gallerySessionId;
};

export const isSessionCancelled = (): boolean => sessionCancelled;

export const shouldIgnoreGallerySessionWork = (capturedGallerySessionId: number): boolean => {
	return sessionCancelled || capturedGallerySessionId !== gallerySessionId;
};

export const isCancelledOperation = (error?: string | {}): boolean => {
	return typeof error === 'string' && error.indexOf(CANCEL_TOKEN) !== -1;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/sessionCancellation.ts